/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb155Inputs */

const en__field_enum_pbs_fb155 = /** @type {(inputs: _Field_Enum_Pbs_Fb155Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 15 Faculty of Biological Sciences`)
};

const de__field_enum_pbs_fb155 = /** @type {(inputs: _Field_Enum_Pbs_Fb155Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 15 Biowissenschaften`)
};

/**
* | output |
* | --- |
* | "F 15 Faculty of Biological Sciences" |
*
* @param {_Field_Enum_Pbs_Fb155Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb155 = /** @type {((inputs?: _Field_Enum_Pbs_Fb155Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb155Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb155(inputs)
	return de__field_enum_pbs_fb155(inputs)
});
export { _field_enum_pbs_fb155 as "_field_enum_PBS_FB15" }